import React, { useState, useEffect } from "react";
import axios from "axios";
import { Col, Row, Button, Table } from "react-bootstrap";
import InputField from "./InputfieldSales";
import baseURL from "../../../../Url/NodeBaseURL";
import { FaEdit, FaTrash } from "react-icons/fa";

const OldSalesForm = ({ setOldSalesData, repairDetails, tabId }) => {
  const [oldDetails, setOldDetails] = useState({
    product: "",
    gross: "",
    total_amount: "",
  });

  const [oldTableData, setOldTableData] = useState(() => {
    const savedData = localStorage.getItem(`oldTableData_${tabId}`);
    return savedData ? JSON.parse(savedData) : [];
  });

  const [editingRow, setEditingRow] = useState(null);

  // Store data in localStorage and send to parent
  useEffect(() => {
    localStorage.setItem(`oldTableData_${tabId}`, JSON.stringify(oldTableData));
    setOldSalesData(oldTableData);
  }, [oldTableData, setOldSalesData]);

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOldDetails((prev) => ({ ...prev, [name]: value }));
  };

  // Add or update entry
  const handleAddButtonClick = () => {
    const { product, gross, total_amount } = oldDetails;

    if (!product || !gross || !total_amount) {
      alert("Please fill in Product, Gross and Total Amount fields.");
      return;
    }

    if (editingRow !== null) {
      // Update existing
      setOldTableData((prev) =>
        prev.map((data, index) => (index === editingRow ? oldDetails : data))
      );
      setEditingRow(null);
    } else {
      // Add new
      setOldTableData([...oldTableData, oldDetails]);
    }

    // Reset fields
    setOldDetails({
      product: "",
      gross: "",
      total_amount: "",
    });
    window.location.reload();
  };

  // Edit entry
  const handleEdit = (data, index) => {
    setOldDetails(data);
    setEditingRow(index);
  };

  // Delete entry
  const handleDelete = (index) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      setOldTableData((prev) => prev.filter((_, i) => i !== index));
      alert("Old Item deleted successfully");
    }
  };

  // Calculate total sum
  const calculateTotalSum = () => {
    return oldTableData
      .reduce((sum, item) => sum + parseFloat(item.total_amount || 0), 0)
      .toFixed(2);
  };

  return (
    <>
      <Row>
        <Col xs={12} md={3}>
          <InputField
            label="Product"
            name="product"
            value={oldDetails.product}
            onChange={handleInputChange}
          />
        </Col>
        <Col xs={12} md={3}>
          <InputField
            label="Gross"
            name="gross"
            value={oldDetails.gross}
            onChange={handleInputChange}
          />
        </Col>
        <Col xs={12} md={3}>
          <InputField
            label="Total Amount"
            name="total_amount"
            value={oldDetails.total_amount}
            onChange={handleInputChange}
          />
        </Col>
        <Col xs={12} md={2}>
          <Button
            onClick={handleAddButtonClick}
            style={{
              backgroundColor: "rgb(163, 110, 41)",
              borderColor: "rgb(163, 110, 41)",
              marginTop: "4px",
              padding: "3px 8px",
              fontSize: "15px",
            }}
          >
            {editingRow !== null ? "Update" : "Add"}
          </Button>
        </Col>
      </Row>

      <Table striped bordered hover>
        <thead style={{ fontSize: "13px" }}>
          <tr>
            <th>Product</th>
            <th>Gross</th>
            <th>Total Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody style={{ fontSize: "13px" }}>
          {oldTableData.map((data, index) => (
            <tr key={index}>
              <td>{data.product}</td>
              <td>{data.gross}</td>
              <td>{data.total_amount}</td>
              <td>
                <FaEdit
                  style={{ cursor: "pointer", marginLeft: "10px", color: "blue" }}
                  onClick={() => handleEdit(data, index)}
                />
                <FaTrash
                  style={{ cursor: "pointer", marginLeft: "10px", color: "red" }}
                  onClick={() => handleDelete(index)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div className="d-flex justify-content-between px-2 mb-1">
        <h7>Total Amount:</h7>
        <h7>₹ {calculateTotalSum()}</h7>
      </div>
    </>
  );
};

export default OldSalesForm;
